
import { defineComponent, Prop } from 'vue'

const points = {
  checkIn: '0,100 100,0',
  checkOut: '100,0 0,100',
}

export default defineComponent({
  props: {
    mode: {
      type: String,
      default: 'checkIn',
      validator: (mode: any) => ['checkIn', 'checkOut'].indexOf(mode) > -1,
    } as Prop<'checkIn'|'checkOut'>,
  },

  setup(props) {
    return {
      points: points[props.mode!],
    }
  }
})
